module.exports = __webpack_public_path__ + "img/گوشه-تیز.34d9920b.png";